import state from './Supplier/states'
import mutations from './Supplier/mutations'
import actions from './Supplier/actions'
import getters from './Supplier/getters'

// 共通
const Store = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default Store
